import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Paging } from 'src/app/api/types/Pageable';
export type VoucherListLayout = 'default' | 'adminVoucher';

export interface VoucherRow {
  id?: number;
  storeId?: number;
  code: string;
  typeText: string;
  displayValue: string;
  initialValue?: string;
  orderMinAmount?: string;
  activeText: string;
  consumedText: string;
  availabilityText: string;
  inactive: boolean;
  source?: string;
  showTopupAction?: boolean;
}

@Component({
  selector: 'app-voucher-list',
  templateUrl: './voucher-list.component.html',
  styleUrls: ['./voucher-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VoucherListComponent {
  @Input() vouchers: VoucherRow[] = [];
  @Input() totalPages = 0;
  @Input() pageNumber = 0;
  @Input() pageSize = 20;
  @Input() isLoaded = true;
  @Input() showGiftCardColumns = false;
  @Input() clickableRows = false;
  @Input() layout: VoucherListLayout = 'default';
  @Output() paginate = new EventEmitter<Paging>();
  @Output() rowClick = new EventEmitter<VoucherRow>();
  @Output() topupClick = new EventEmitter<VoucherRow>();

  get hasTopupActions(): boolean {
    return this.vouchers.some((row) => row.showTopupAction);
  }
  get isAdminVoucherLayout(): boolean {
    return this.layout === 'adminVoucher';
  }

  get noDataColspan(): number {
    if (this.isAdminVoucherLayout) {
      return this.hasTopupActions ? 7 : 6;
    }

    return this.hasTopupActions ? 9 : 8;
  }

  onRowClick(row: VoucherRow): void {
    if (this.clickableRows) {
      this.rowClick.emit(row);
    }
  }

  onTopupClick(event: Event, row: VoucherRow): void {
    event.stopPropagation();
    this.topupClick.emit(row);
  }
}
